// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/customer_order/fee/v1/fee.proto (package stailer_service_specification.customer_order.fee.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { enumDesc, fileDesc, messageDesc, tsEnum } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_enum_description } = require("../../../../description_support/v1/enum_description_pb");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/customer_order/fee/v1/fee.proto.
 */
const file_stailer_service_specification_customer_order_fee_v1_fee = /*@__PURE__*/
  fileDesc("Cj1zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9jdXN0b21lcl9vcmRlci9mZWUvdjEvZmVlLnByb3RvEjNzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5jdXN0b21lcl9vcmRlci5mZWUudjEirQQKA0ZlZRKLAgoMZmVlX3RheF90eXBlGAIgASgOMjwuc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24uY3VzdG9tZXJfb3JkZXIuZmVlLnYxLlRheFR5cGVCtgGSghmQAeazqOaWh+OBq+iqsuOBleOCjOOCi+aJi+aVsOaWme+8iOmFjemBlOaWmeODu+OCteODvOODk+OCueaJi+aVsOaWme+8ieOBqOOBl+OBpuioseWPr+OBmeOCi+eojuWMuuWIhu+8iOWklueojuOBvuOBn+OBr+WGheeoju+8ieOCkuaMh+WumuOBl+OBvuOBmaqCGRXmiYvmlbDmlpnjga7nqI7ljLrliIa4ghkByIIZARKRAgoSaGFzX3JlZGVsaXZlcnlfZmVlGAMgASgIQvQBkoIZzQHlho3phY3pgZTmmYLjgavmiYvmlbDmlpnjgYznmbrnlJ/jgZnjgovjg5Hjg7zjg4jjg4rjg7zjgYvjganjgYbjgYvjgpLmjIflrprjgZfjgb7jgZnjgIJTdGFpbGVy44Gn44Gv5YaN6YWN6YGU5pmC44Gr5omL5pWw5paZ5b605Y+O44Gu5qmf6IO944Gv44Gq44GE44Gu44Gn5Y2Y44Gr44Ks44Kk44OJ6KGo56S65pyJ54Sh44Gg44GR44Gr44Gq44KK44G+44GZ44CCqoIZEuWGjemFjemBlOaJi+aVsOaWmbiCGQHAghkByIIZAUoECAEQAiqLAgoHVGF4VHlwZRI6ChRUQVhfVFlQRV9VTlNQRUNJRklFRBAAGiDqghkP5pyq5oyH5a6a44Gn44GZ+oIZCeacquaMh+WumhJhChFUQVhfVFlQRV9FWENMVURFRBABGkrqghk85omL5pWw5paZ6YeR6aGN44GM56iO5oqc5L6h5qC844Gn44GC44KL44GT44Go44KS56S644GX44G+44GZ+oIZBuWklueojhJhChFUQVhfVFlQRV9JTkNMVURFRBACGkrqghk85omL5pWw5paZ6YeR6aGN44GM56iO6L685L6h5qC844Gn44GC44KL44GT44Go44KS56S644GX44G+44GZ+oIZBuWGheeojmIGcHJvdG8z", [file_description_support_v1_enum_description, file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.customer_order.fee.v1.Fee.
 * Use `create(FeeSchema)` to create a new message.
 */
const FeeSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_customer_order_fee_v1_fee, 0);

/**
 * Describes the enum stailer_service_specification.customer_order.fee.v1.TaxType.
 */
const TaxTypeSchema = /*@__PURE__*/
  enumDesc(file_stailer_service_specification_customer_order_fee_v1_fee, 0);

/**
 * 税区分（外税 or 内税）を表します。
 *
 * @generated from enum stailer_service_specification.customer_order.fee.v1.TaxType
 */
const TaxType = /*@__PURE__*/
  tsEnum(TaxTypeSchema);


exports.file_stailer_service_specification_customer_order_fee_v1_fee = file_stailer_service_specification_customer_order_fee_v1_fee;
exports.FeeSchema = FeeSchema;
exports.TaxTypeSchema = TaxTypeSchema;
exports.TaxType = TaxType;
